import React from 'react';

export const handleErrorMessages = (message) => {
    var messages = message.split('|');

    return messages.map((message, i) =>
        <li key={i}><span></span>{message}</li>
    );
}


// WEBPACK FOOTER //
// ./src/components/OnBoarding/error/services/messageService.js